import { adminApiRequest } from "../../utils/apiUtils";

export interface GameInspectionScheduleDto {
  isInspection: boolean;
  endAt: string;
}
export const GameInspectionScheduleAPI = {
  getGameInspectionSchedule: () => {
    return adminApiRequest
      .get("/game-inspection-schedule")
      .then((res) => res.data);
  },
  saveGameInspectionSchedule: (request: GameInspectionScheduleDto) => {
    return adminApiRequest
      .post("/game-inspection-schedule/update", request)
      .then((res) => res.data);
  },
};
